function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./HelperText.style";
import { resolveIds } from "../../utils/resolveIds";
import AlertTriangle from "../Icon/AlertTriangle";
export var HelperText = function(param) {
    var children = param.children, tmp = param.errorIcon, ErrorIcon = tmp === void 0 ? AlertTriangle : tmp, id = param.id, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _hasError = param.hasError, hasError = _hasError === void 0 ? false : _hasError, testID = param.testID;
    var ref = useStyle({
        hasError: hasError,
        isRtl: isRtl
    }), message = ref.message, error = ref.error;
    if (children === undefined) {
        return null;
    }
    return _jsxs("div", _objectSpread({}, resolveIds(id, testID), {
        css: message,
        children: [
            hasError && _jsx(ErrorIcon, {
                color: "".concat(error === null || error === void 0 ? void 0 : error.color)
            }),
            children
        ]
    }));
};
export default HelperText;
